import PocketBase from 'pocketbase';

/**
 * PocketBase client singleton (Task 1.3 groundwork, consumed by SyncWorker).
 *
 * - Single instance per tab: one SSE connection pool, one auth store.
 * - Auth is persisted in localStorage by the SDK; tokens never touch app
 *   state that could be logged or serialized into Dexie payloads.
 * - `autoCancellation` stays ENABLED globally (default) so unmounted React
 *   components cancel in-flight requests; long-lived sync calls opt out
 *   explicitly via `{ $autoCancel: false }` in SyncWorker only.
 */

const baseUrl =
  import.meta.env?.VITE_POCKETBASE_URL || 'http://127.0.0.1:8090';

export const pb = new PocketBase(baseUrl);

// Never let the SDK silently send a stale Authorization header: on auth
// failure the AuthContext must drive re-authentication, not the transport.
pb.beforeSend = function (url, options) {
  if (!pb.authStore.isValid && options.headers?.Authorization) {
    delete options.headers.Authorization;
  }
  // SDK ≥0.26 requires the object form ({ url, options }); returning bare
  // options logs a deprecation warning in production builds.
  return { url, options };
};

export const PB_BASE_URL = baseUrl;
export default pb;
